import { render, staticRenderFns } from "./badBehaviorDetail.vue?vue&type=template&id=17173082&scoped=true"
import script from "./badBehaviorDetail.vue?vue&type=script&lang=js"
export * from "./badBehaviorDetail.vue?vue&type=script&lang=js"
import style0 from "./badBehaviorDetail.vue?vue&type=style&index=0&id=17173082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17173082",
  null
  
)

export default component.exports